import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { GetCrossCodeService } from './api-services/get-cross-code.service';
import { GetCrossGoodsInfoListService } from './api-services/get-cross-goods-info-list.service';
import { GetPcodeGoodsInfoService } from './api-services/get-pcode-goods-info.service';
import { KYMW4801Component } from './kymw4801.component';
import { DeleteCrossSetServive } from './api-services/delete-cross-set.service';
import { RegistCrossSetServive } from './api-services/regist-cross-set.service';
import { UpdateCrossSetService } from './api-services/update-cross-set.service';
import { CheckUnselectedGoodsService } from './api-services/check-unselected-goods.service';

/**
 * クロス設定登録画面 モジュール設定クラス
 *
 * @export KYMW4801Module
 * @class KYMW4801Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [KYMW4801Component],
  providers: [
    GetCrossCodeService,
    GetCrossGoodsInfoListService,
    GetPcodeGoodsInfoService,
    DeleteCrossSetServive,
    RegistCrossSetServive,
    UpdateCrossSetService,
    CheckUnselectedGoodsService,
  ],
})
export class KYMW4801Module { }
